import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_USER_ACCOUNT_BALANCE } from "../../../../../../Utils/AllPagesQuriesAndMutations";
import { NumberFormatter } from "../../../../../CommonFunction/NumberFormatter/NumberFormatter";
import Button from "../../../../Button/Button";
import EmtPortalFooter from "../../../../LpComponents/Reactportal/PortalFooter";
import Spinner from "../../../Spinner/Spinner";
import "./ProcessAdvanceModal.scss";

function ProcessAdvanceModal({
  editCommittedVehiclesData,
  onClose,
  advance,
  loading,
  LpId,
}) {
  const [accBal, setAccBal] = useState(0);
  const [remainingBal, setRemainingBal] = useState(0);
  let { data, loading: balLoad } = useQuery(GET_USER_ACCOUNT_BALANCE, {
    variables: { UserId: LpId },
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });

  function invertNumber(number) {
    return number * -1;
  }
  useEffect(() => {
    if (data) {
      setAccBal(
        invertNumber(data?.GetAccountBalanceIdWithUserId[0]?.Account_Balance)
      );
      setRemainingBal(
        invertNumber(data?.GetAccountBalanceIdWithUserId[0]?.Account_Balance) -
          advance
      );
    }
  }, [data]);

  return (
    <div className="processAdvanceDiv">
      <div className="eachProcessAdvanceDiv">
        <p className="processAdvanceHeading">Current Bal :</p>
        <p className="processAdvanceText">
          {accBal && NumberFormatter(accBal)}/-
        </p>
      </div>
      <div className="eachProcessAdvanceDiv">
        <p className="processAdvanceHeading">Amount to be paid :</p>
        <p className="processAdvanceText">
          {NumberFormatter(Math.round(advance))} /-
        </p>
      </div>
      <div className="eachProcessAdvanceDiv">
        <p className="processAdvanceHeading">Remaining Balance :</p>
        <p className="processAdvanceText">
          {remainingBal && NumberFormatter(Math.round(remainingBal))}/-
        </p>
      </div>
      {remainingBal < 0 && (
        <p className="insufficientBalText">Insufficient Balance</p>
      )}

      <p className="processAdvanceCnfMessage">
        Are you sure to Process Advance ?
      </p>

      <EmtPortalFooter>
        {loading ? (
          <Button
            text={<Spinner />}
            className="loadingAcceptBtn"
            type="button"
          />
        ) : (
          <Button
            text={"Confirm"}
            name="modalbutton"
            className={remainingBal < 0 ? "acceptBtndisabled" : "acceptBtn"}
            disabled={remainingBal < 0 ? true : false}
            type="submit"
            action={editCommittedVehiclesData}
          />
        )}

        <Button
          text={"Cancel"}
          name="modalbutton"
          className="rejectBtn"
          action={onClose}
        />
      </EmtPortalFooter>
    </div>
  );
}

export default ProcessAdvanceModal;
